<input id="slider-valor" type="text" data-provide="slider" ticks_tooltip="true" />